import { render, staticRenderFns } from "./debit-notes.vue?vue&type=template&id=977606dc"
import script from "./debit-notes.vue?vue&type=script&lang=js"
export * from "./debit-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports